// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const customizeViewAPI = createApi({
  reducerPath: "customizeViewAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["view"],
  endpoints: (builder) => ({
    getViewsList: builder.query<any, getViewArgsType>({
      query: ({ type }) => ({
        url: `/am/view/type/${type}`,
        method: "GET",
      }),
      providesTags: ["view"],
    }),

    createViews: builder.mutation<any, createViewArgsType>({
      query: ({ payload }) => ({
        url: `/am/view/create`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["view"],
    }),

	updateViews: builder.mutation<any, updateViewArgsType>({
        query: ({ payload }) => ({
          url: `/am/view/update`,
          method: "PUT",
          data: payload,
        }),
        invalidatesTags: ["view"],
      }),

	deleteView: builder.mutation<any, viewArgTypes>({
		query: ({viewId}) => ({
			url: `/am/view/${viewId}`,
			method: "delete",
		  }),
		  invalidatesTags: ["view"],

	}),

	getViewDetails: builder.query<any, viewArgTypes>({
		query: ({ viewId }) => ({
		  url: `/am/view/${viewId}`,
		  method: "GET",
		}),
	  }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetViewsListQuery,
  useLazyGetViewDetailsQuery,
  useGetViewDetailsQuery,
  useCreateViewsMutation,
  useUpdateViewsMutation,
  useDeleteViewMutation,
} = customizeViewAPI;
